import { getCompany, getUserId } from '../_utils/storage_handler';
import { sendFetch, POST_OPTIONS, GET_OPTIONS } from './base.service';


const BASE_PATH = '/client-percent';

export const create = async (body) => {
    return await sendFetch(`${BASE_PATH}/create`, POST_OPTIONS, body);
}

export const update = async (body) => {
    return await sendFetch(`${BASE_PATH}/update`, POST_OPTIONS, body);
}